﻿// search input
export const SEARCH_INPUT_ELEM = () => $('[data-action="search-input"]');

export const SEARCH_BUTTON_ELEM = () => $('[data-action="search-btn"]');

export const $SEARCH_CATEGORY_ELEM = $('[data-identity="search-category"]');